import { __assign, __read, __spread } from "tslib";
import { parse, Kind, isSchema } from 'graphql';
import { isSourceTypes, isStringTypes, isSchemaDefinition } from './utils';
import { mergeGraphQLNodes } from './merge-nodes';
import { resetComments, printWithComments } from './comments';
import { createSchemaDefinition, printSchemaWithDirectives } from '@graphql-tools/utils';
export function mergeTypeDefs(types, config) {
    resetComments();
    var doc = {
        kind: Kind.DOCUMENT,
        definitions: mergeGraphQLTypes(types, __assign({ useSchemaDefinition: true, forceSchemaDefinition: false, throwOnConflict: false, commentDescriptions: false }, config)),
    };
    var result;
    if (config && config.commentDescriptions) {
        result = printWithComments(doc);
    }
    else {
        result = doc;
    }
    resetComments();
    return result;
}
export function mergeGraphQLTypes(types, config) {
    resetComments();
    var allNodes = types
        .map(function (type) {
        if (Array.isArray(type)) {
            type = mergeTypeDefs(type);
        }
        if (isSchema(type)) {
            return parse(printSchemaWithDirectives(type));
        }
        else if (isStringTypes(type) || isSourceTypes(type)) {
            return parse(type);
        }
        return type;
    })
        .map(function (ast) { return ast.definitions; })
        .reduce(function (defs, newDef) {
        if (newDef === void 0) { newDef = []; }
        return __spread(defs, newDef);
    }, []);
    // XXX: right now we don't handle multiple schema definitions
    var schemaDef = allNodes.filter(isSchemaDefinition).reduce(function (def, node) {
        node.operationTypes
            .filter(function (op) { return op.type.name.value; })
            .forEach(function (op) {
            def[op.operation] = op.type.name.value;
        });
        return def;
    }, {
        query: null,
        mutation: null,
        subscription: null,
    });
    var mergedNodes = mergeGraphQLNodes(allNodes, config);
    var allTypes = Object.keys(mergedNodes);
    if (config && config.sort) {
        allTypes.sort(typeof config.sort === 'function' ? config.sort : undefined);
    }
    if (config && config.useSchemaDefinition) {
        var queryType = schemaDef.query ? schemaDef.query : allTypes.find(function (t) { return t === 'Query'; });
        var mutationType = schemaDef.mutation ? schemaDef.mutation : allTypes.find(function (t) { return t === 'Mutation'; });
        var subscriptionType = schemaDef.subscription ? schemaDef.subscription : allTypes.find(function (t) { return t === 'Subscription'; });
        schemaDef = {
            query: queryType,
            mutation: mutationType,
            subscription: subscriptionType,
        };
    }
    var schemaDefinition = createSchemaDefinition(schemaDef, {
        force: config.forceSchemaDefinition,
    });
    if (!schemaDefinition) {
        return Object.values(mergedNodes);
    }
    return __spread(Object.values(mergedNodes), [parse(schemaDefinition).definitions[0]]);
}
//# sourceMappingURL=merge-typedefs.js.map